module.exports = __webpack_public_path__ + "static/media/recipo_ad.1099def9.png";